/* eslint-disable @typescript-eslint/ban-ts-comment */
import { getLocale, getTimezone } from '../settings/utils';

interface RangeToParts {
  type: 'day' | 'literal' | 'month' | 'year' | 'weekday';
  source: 'startRange' | 'shared' | 'endRange';
  value: string;
}

const parseDate = (value: Date | string) =>
  typeof value === 'string' ? new Date(Date.parse(value)) : value;

export const formatDate = (
  value: Date | string,
  options?: Intl.DateTimeFormatOptions,
) =>
  new Intl.DateTimeFormat(getLocale(), {
    timeZone: getTimezone(),
    ...options,
  }).format(parseDate(value));

export const formatDateRangeToParts = (
  firstTime: Date | string,
  secondTime: Date | string,
  options?: Intl.DateTimeFormatOptions,
): RangeToParts[] =>
  // @ts-ignore
  new Intl.DateTimeFormat(getLocale(), {
    timeZone: getTimezone(),
    ...options,
  }).formatRangeToParts(parseDate(firstTime), parseDate(secondTime));
